// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  apiConfig: {
    fidjiAfURL: '//dlydrm-beta.immanens-delivery.com/services/fidji/',
    imageServerURL: 'https://docimg.immanens.com/phxaf/',
  },
  fixedDeviceSettings: {
    device_description: window.navigator.userAgent,
    device_os: window.navigator.appVersion,
    device_token: '5fff7a7cc24d6c8a9d99021a9396ac1a32101efc4822651565bd85906b5399fec5eba63f98a9adc0cda8102bc0964cc194279cc3f4e2fee76442ac20507bfcd35cac8216b5107f1dfbbb184ee9124f10bc32da47948844a9bbffcf705950ecc60cbe9f91269f98b1e487607888ce995dae2c5ac224c906c19bea5a41e9019eb902e51a84d7ba73ddb0b7cf2c1e2b26f8',
    imm_app_id: 111, // Delimobi
    api_key: 'dlmbhb163nfop',
    app_version: 'undefine'
  },
  VERSION: '1.0.1' // Check it in package.json
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts